export enum CommonSizeEnum {
  HUGE = 'huge',
  MEDIUM = 'medium',
  SMALL = 'small',
}
